import SlimSelect from 'slim-select'
import "../../../node_modules/slim-select/dist/slimselect.css"

export class SelectInput extends HTMLSelectElement {
    connectedCallback() {
        this.select = new SlimSelect({
            select: this,
            settings: {
                searchText: 'Aucun résultat trouvé',
                searchPlaceholder: 'Rechercher',
                searchHighlight: true,
                allowDeselect: true,
                showSearch: (/true/).test((this.dataset.search || 'true').toLowerCase())
            }
        });

    }

    disconnectedCallback() {
        this.select.destroy()
    }
}

export class SelectInputAddable extends HTMLSelectElement {

    connectedCallback() {
        this.select = new SlimSelect({
            select: this,
            settings: {
                searchText: 'Aucun résultat trouvé',
                searchPlaceholder: 'Rechercher',
                searchHighlight: true,
                allowDeselect: true,
            },
            events: {
                addable: function (value) {
                    // return false or null if you do not want to allow value to be submitted
                    if (value === 'bad') {
                        return false
                    }

                    // Return the value string
                    return value // Optional - value alteration // ex: value.toLowerCase()

                    // Optional - Return a valid data object.
                    // See methods/setData for list of valid options
                    return {
                        text: value,
                        value: value.toLowerCase()
                    }

                    // Optional - Return a promise with either a string or data object
                    return new Promise((resolve) => {
                        resolve({
                            text: value,
                            value: value,
                        })
                    })
                }
            }
        });
    }

    disconnectedCallback() {
        this.select.destroy()
    }
}

